'use strict';

module.exports = {
  validateEmailForm: function () {
    $('.check-email-submit-btn').on('click', function () {
      var email = $("#check-email-input").val();

      // Réinitialiser les messages d'erreur
      $(".invalid-feedback-email").empty();

      var regex = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
      var partsAfterLastDot = email.split('.').pop();

      var errorMessageEmpty = $('.login-form-check').data('email-check-empty'),
        errorMessageValid = $('.login-form-check').data('email-check-valid'),
        errorMessageFull = $('.login-form-check').data('email-check-full'),
        errorMessageAfter = $('.login-form-check').data('email-check-after'),
        errorMessageAfterText = $('.login-form-check').data('email-check-after-text'),
        errorMessageBefore = $('.login-form-check').data('email-check-before'),
        errorMessageMissingPoint = $('.login-form-check').data('email-check-missing-point'),
        errorMessageMissingPointText = $('.login-form-check').data('email-check-missing-point-text');

      // Conditions de validation
      if (email === "") {
        $(".invalid-feedback-email").text(errorMessageEmpty);
      } else if (email.split("@")[0].indexOf("?") !== -1) {
        $(".invalid-feedback-email").text(errorMessageBefore);
      } else if (email.indexOf("@") === -1) {
        $(".invalid-feedback-email").text(errorMessageFull + " " + '"' + email + '"' + ".");
      } else if (email.indexOf("@") === -1 || email.split("@")[1] === "") {
        $(".invalid-feedback-email").text(errorMessageAfter + " " + email + " " + errorMessageAfterText);
      } else if (partsAfterLastDot.length === 0) {
        $(".invalid-feedback-email").text(errorMessageMissingPoint + ' "' + email.split('@')[1] + '"' + errorMessageMissingPointText + ".");
      } else if (!regex.test(email) && (email.indexOf("@") === -1 || email.split("@")[1] === "")) {
        $(".invalid-feedback-email").text(errorMessageValid);
      } else if (!regex.test(email)) {
        $(".invalid-feedback-email").text(errorMessageValid);
      }
      setTimeout(function () {
        $('.btn-loader .loading').addClass('no-load');
      }, 500);
    });
  }
};